import React from "react";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./StatusTag.module.scss";

/**
 * StatusTag — etiqueta de estado reaprovechable del design system.
 *
 * Mapea el `status` de una tarea (draft|active|archived) a un Tag de marca
 * (pill, colores semanticos de tokens.js). Pensado para reusarse en cualquier
 * listado con estados (tareas, itinerarios, evaluaciones...).
 *
 * Props:
 *  - status: "draft" | "active" | "archived"
 *  - label?: texto a mostrar (si se omite, se traduce con el namespace tasks)
 */
const VARIANT = {
  active: styles.active,
  archived: styles.archived,
  draft: styles.draft,
};

export function StatusTag({ status = "draft", label }) {
  const { t } = useTranslation("tasks");

  const text =
    label ??
    (status === "active"
      ? t("list.statusActive")
      : status === "archived"
        ? t("list.statusArchived")
        : t("list.statusDraft"));

  return (
    <Tag className={`${styles.tag} ${VARIANT[status] || styles.draft}`}>
      <span className={styles.dot} />
      {text}
    </Tag>
  );
}

export default StatusTag;
